import {TablePagination} from "@mui/material";
import { t } from "@lingui/core/macro";

interface PropsType {
    totalItems: number,
    page: number,
    pageSize: number,
    handleChangePage: (number) => void,
    handleChangePageSize: (number) => void,
}

const ContractorUserListPagination = ({totalItems, page, pageSize, handleChangePage, handleChangePageSize}: PropsType) => {
    return (totalItems ?
        <TablePagination
            width="100%"
            component="div"
            rowsPerPageOptions={[5, 10, 15, 25, 50, 200]}
            colSpan={5}
            count={totalItems}
            rowsPerPage={pageSize}
            showFirstButton={true}
            showLastButton={true}
            page={page}
            SelectProps={ {
                inputProps: {
                    'aria-label': t`rows per page`,
                },
                native: true,
            } }
            onPageChange={(_, page) => {
                handleChangePage(page)
            }}
            onRowsPerPageChange={(e) => {
                handleChangePageSize(Number(e.target.value))
            }}
        />
        :
        <></>
    )
}
export default ContractorUserListPagination;
